<div class="powered-by" [class.desktop]="desktop">
  <div class="powered-by-content">
    <span class="label">Bereitgestellt von</span>
    <a
      href="https://www.finanzen.net/"
      target="_blank"
      rel="noopener noreferrer"
      class="logo-link"
      aria-label="finanzen.net – öffnet in neuem Tab"
    >
      <img [src]="logoSrc()" alt="" width="106" height="16" class="logo" />
    </a>
  </div>

  @if (desktop) {
    <button class="close-btn" (click)="closeClicked.emit()" aria-label="Schließen">
      <img [src]="closeIconSrc()" alt="" width="12" height="12" />
    </button>
  } @else {
    <app-v3-info-button></app-v3-info-button>
  }
</div>
